import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _Promise from "babel-runtime/core-js/promise";

var _this2 = this;

import sysConfig from "../config/sysConfig";
import definecfg from "../config/defineConfig";
import dateFormat from "../tools/format.js";
import oppService from "../service/opp-service";
import storage from "../tools/storage.js";
import store from "../vuex";
import types from "@/vuex/mutation-types";
import baseConfig from "../config/baseConfig";


var fsEncrypt = require("../tools/libs/fs-enc");

export var getBankCodeByImageCls = function getBankCodeByImageCls(imgCls) {
  return sysConfig.$syscfg.K_Request("Y1002203", {
    IMG_CLS: imgCls
  }).then(function (d) {
    return d.Code == "0" && d.Data && d.Data[0];
  });
};

export var acceptDoubleRecordTask = function acceptDoubleRecordTask(bSno) {
  consoleLog("双录发起流程,bsno:" + bSno);
  return sysConfig.$syscfg.K_Request("W0000122", {
    ACCEPT_TYPE: 1,
    B_SNO: bSno
  });
};

export var getImgClass = function getImgClass(bsno, busiScope, busiData) {
  if (busiData && ["V0133", "V0149"].includes(busiData.BUSI_CODE)) {
    return _Promise.resolve({
      Code: "0",
      Data: busiData.IMG_CLS
    });
  } else {
    return sysConfig.$syscfg.K_Request("F0000044", {
      B_SNO: bsno,
      BUSI_SCOPE: busiScope
    });
  }
};

export var getImgInfo = function getImgInfo(bSno, busiType) {
  return sysConfig.$syscfg.K_Request("Y1002034", {
    B_SNO: bSno,
    REF_BUSI_TYPE: busiType || ""
  });
};

export var getImgFrames = function getImgFrames(imgCls) {
  return sysConfig.$syscfg.K_Request("Y1002101", {
    IMG_CLS: imgCls
  });
};

export var assembledImaUrl = function assembledImaUrl(item) {
  return sysConfig.$syscfg.getImgUrl(true).then(function (imgConfig) {
    var buildUrl = imgConfig.kidmDownload + "?",
        queryParam = "IMG_SN=" + item.IMG_SN + (item.PAGE_NUM ? "&PAGE_NUM=" + item.PAGE_NUM : "");

    return buildUrl + (item.isEncode ? "param=" + encodeURIComponent(fsEncrypt.encrypt(queryParam)) : queryParam);
  });
};

export var getCollectedImgData = function getCollectedImgData(B_SNO, imgCls, relaImgCls) {
  return sysConfig.$syscfg.K_Request("F0000037", {
    SERVICE_CODE: "D1000552",

    B_SNO: B_SNO,
    IMG_CLS: imgCls,
    RELA_IMG_CLS: relaImgCls || ""
  });
};

export var getQrCode = function getQrCode(APPT_SN, BUSI_CODE, USER_TYPE) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  return sysConfig.$syscfg.K_Request("F0000040", {
    APPT_SN: APPT_SN,
    BUSI_CODE: BUSI_CODE,
    USER_TYPE: USER_TYPE,
    isCust: "0",
    type: type
  });
};

export var ocrOrgInfo = function ocrOrgInfo(imgdata) {
  return sysConfig.$syscfg.K_Request("F0000014", {
    imgData: imgdata
  });
};

export var ocrAgentInfo = function ocrAgentInfo(imgdata) {
  return sysConfig.$syscfg.K_Request("F0000023", {
    imgData: imgdata
  });
};

export var ocrGetInfo = function ocrGetInfo(type, img) {
  return sysConfig.$syscfg.K_Request("F0000037", {
    SERVICE_CODE: "D9900016",
    ID_TYPE: type,
    IMG_PHOTO1: img
  });
};

export var saveDoubleRecordData = function saveDoubleRecordData(params) {
  return sysConfig.$syscfg.K_Request("W0000319", params);
};

export var saveBusiData = function saveBusiData(busiData) {
  return sysConfig.$syscfg.K_Request("F0000037", {
    SERVICE_CODE: "D1000596",
    B_SNO: busiData.B_SNO,
    BUSI_CODE: busiData.BUSI_CODE,
    BUSI_DETAIL: busiData.BUSI_DETAIL || "",
    SYS_CUST_NO: busiData.CUST_CODE,
    ORG_CODE: busiData.ORG_CODE,
    CUST_NAME: busiData.CUST_NAME,
    ID_TYPE: busiData.ID_TYPE,
    USER_TYPE: busiData.USER_TYPE,
    ID_CARD: busiData.ID_CODE,
    SYS_CODE: busiData.SYS_CODE,
    CHANNEL: busiData.CHANNEL || "10",
    ACCEPT_PARAM: busiData.ACCEPT_PARAM,
    DEAL_PARAM: ""
  });
};

export var saveAgreement = function saveAgreement(busiData) {
  return sysConfig.$syscfg.K_Request("F0000037", {
    SERVICE_CODE: "D2000048",
    KIDM_SNO: busiData.KIDM_SNO,
    BUSI_CODE: busiData.BUSI_CODE,
    IMG_CLSS: busiData.IMG_CLSS || "",
    CHANNEL: "13",
    USER_TYPE: busiData.USER_TYPE,
    SYS_CODE: "99",
    ORG_CODE: busiData.ORG_CODE,
    FILE_STATUS: "1",
    IS_SHOW_ERROR: "0",
    IMG_FMT: "3"
  });
};

export var uploadMedia = function uploadMedia(ft, mediaPath, mediaUriOption, onSuccess, onError, onProgress, mimeType) {
  mimeType = mimeType || "image/jpeg";

  sysConfig.$syscfg.getImgUrl().then(function (cfg) {
    var uri = "";
    for (var key in mediaUriOption) {
      var value = mediaUriOption[key];
      if (uri == "") {
        uri += "?" + key + "=" + value;
      } else {
        uri += "&" + key + "=" + value;
      }
    }

    uri = cfg.kidmUpload + uri;
    var options = new FileUploadOptions();
    options.fileKey = "file";
    options.fileName = mediaPath.substr(mediaPath.lastIndexOf("/") + 1);
    options.mimeType = mimeType;
    options.chunkedMode = false;

    ft.onprogress = onProgress;
    ft.upload(mediaPath, uri, onSuccess, onError, options, true);
  }).catch(function (err) {
    onError(err);

    consoleLog("catch错误====" + err);
  });
};

export var uploadMediaFlie = function uploadMediaFlie(url, params) {
  return new _Promise(function (resolve, reject) {
    var uri = "",
        uploadUrl = baseConfig.$basecfg.httpConfig.baseUrl.replace("vtm/services/RestService", "vtm/fileUpload");

    for (var key in params) {
      var value = params[key];
      if (uri == "") {
        uri += "?" + key + "=" + value;
      } else {
        uri += "&" + key + "=" + value;
      }
    }
    uri = uploadUrl + uri;
    consoleLog("即将上传的uri:", uri);
    utyDevice.HttpPutTask(uri, url).then(function (result) {
      consoleLog("本地双录厂商上传的调用结果：", result);
      if (result) {
        result = JSON.parse(_.isString(result) ? result : result.data);
        if (result && result.code == "-999") {
          reject(result.msg);
        } else {
          resolve(result[0].data[0]);
        }
      } else {
        reject("本地双录调用厂商上传的方法失败");
      }
    }).catch(function (error) {
      console.log("本地双录调用厂商上传的方法失败", error);
      reject("本地双录调用厂商上传的方法失败");
    });
  });
};

export var upCollectedImgData = function upCollectedImgData(sysCust) {
  if (sysConfig.$syscfg.isOpenAcctBiz(sysCust.BUSI_CODE)) {
    sysCust.CUST_CODE = "0";
    sysCust.SYS_CUST_NO = "0";
  }
  return sysConfig.$syscfg.K_Request("F0000043", _Object$assign({
    SERVICE_CODE: "D1000602"
  }, sysCust));
};

export var batchUpCollectedImgData = function batchUpCollectedImgData(params) {
  if (sysConfig.$syscfg.isOpenAcctBiz(params.BUSI_CODE)) {
    params.CUST_CODE = "0";
    params.SYS_CUST_NO = "0";
  }
  return sysConfig.$syscfg.K_Request("F0000083", params);
};

export var deleteCollectedImgData = function deleteCollectedImgData(sysCust) {
  return sysConfig.$syscfg.K_Request("F0000037", _Object$assign({
    SERVICE_CODE: "D7700035" }, sysCust));
};

export var uploadImgInfoToYgt = function uploadImgInfoToYgt(param) {
  return new _Promise(function (resolve, reject) {
    sysConfig.$syscfg.K_Request("W0000123", _Object$assign({
      REVIEW_STATUS: "1",
      IMG_PAGE_CNT: 0,
      IMG_SIZE: 0,
      IMG_WIDTH: 0,
      IMG_HEIGHT: 0,
      BITMAP_TYPE: 0,
      BITMAP_BITS: 0,
      BITMAP_XDPI: 0,
      BITMAP_YDPI: 0,
      IMG_UPLOAD: ""
    }, param)).then(function (data) {
      resolve(data);
    }).catch(function (e) {
      reject(e);
    });
  });
};

export var getDownImgFileInfoData = function getDownImgFileInfoData(param) {
  return new _Promise(function (resolve, reject) {
    sysConfig.$syscfg.K_Request("F6022003", param).then(function (data) {
      if (data.Code == "0") {
        resolve(data.Data);
      } else {
        reject("获取已采集信息失败：" + data.Msg);
      }
    });
  });
};

export var getKidmImgContent = function getKidmImgContent(param) {
  return sysConfig.$syscfg.K_Request("Y1002034", param).then(function (data) {
    if (data.Code == "0" && data.Data.length > 0) {
      return data.Data[0] || {};
    }
    return {};
  }).catch(function (e) {
    console.log("获取影像系统数据失败", e);
  });
};

export var getKidmImgclsCollectFlag = function getKidmImgclsCollectFlag(param) {
  return sysConfig.$syscfg.K_Request("F0000037", _Object$assign({}, { SERVICE_CODE: "D1000596" }, param)).then(function (data) {
    if (data.Code == "0" && data.Data.length > 0) {
      return data.Data[0] || {};
    }
    return {};
  }).catch(function (e) {
    console.log("获取影像系统数据失败", e);
  });
};

export var saveKidmImgclsCollectFlag = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, imgClsArr) {
    var BUSI_COMM_PARAM, needSaveDataToKidmImgclsArr, busiInfo, IMG_CLS;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            BUSI_COMM_PARAM = _this.$storage.getJsonLocal(_this.$definecfg.BUSI_COMM_PARAM);
            needSaveDataToKidmImgclsArr = BUSI_COMM_PARAM && _.find(BUSI_COMM_PARAM, { PARAM_CODE: "NEED_RECOLLECT_IMG_CLS" }) || {};

            needSaveDataToKidmImgclsArr = needSaveDataToKidmImgclsArr.PARAM_VALUE || "056,04x,X2r,Xb0,Xb9,Xb6,Xbc,X2H,X91,X2t,Xbf,X24,Xbg,010,Xb7,Xb8,X9E,Xb4,0x3,Xb5,X1C,X2F,Xb2,X2p";
            busiInfo = _this.$storage.getJsonSession(_this.$definecfg.OLD_BIZ_DATA) || {};
            IMG_CLS = [];

            _.each(imgClsArr, function (item) {
              if (needSaveDataToKidmImgclsArr.indexOf(item.IMG_CLS) > -1 && item.REVIEW_STATUS == "1") {
                IMG_CLS.push(item.IMG_CLS);
              }
            });

            if (busiInfo.KIDM_SNO) {
              _context.next = 9;
              break;
            }

            _this.alert("影像数据更新失败，影像流水号不能为空");
            return _context.abrupt("return");

          case 9:
            if (!_this.isDisabled) {
              _context.next = 12;
              break;
            }

            consoleLog("当前页面禁用，不更新重采业务影像资料");
            return _context.abrupt("return");

          case 12:
            if (IMG_CLS.length) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return sysConfig.$syscfg.K_Request("F0000037", _Object$assign({}, { SERVICE_CODE: "D7700026" }, {
              B_SNO: busiInfo.KIDM_SNO,
              BUSI_CODE: busiInfo.BUSI_CODE,
              CHANNEL: "13",
              ACCEPT_PARAM_FROM_DATABASE: "1",
              IMG_CLS: IMG_CLS.join(","),
              USER_TYPE: busiInfo.USER_TYPE
            })).then(function (data) {
              _this.$store.commit(_this.$types.UPDATE_PAGE_RELOAD, false);
              if (data.Code == "0" && data.Data.length > 0) {
                return data.Data[0] || {};
              }
              return {};
            }).catch(function (e) {
              console.log("获取影像系统数据失败 saveKidmImgclsCollectFlag", e);
            });

          case 16:
            return _context.abrupt("return", _context.sent);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this2);
  }));

  return function saveKidmImgclsCollectFlag(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export var getPrintImgClsCollectFlag = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
    var busiInfo;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            busiInfo = _this.$storage.getJsonSession(_this.$definecfg.OLD_BIZ_DATA) || {};

            if (!busiInfo.KIDM_SNO) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return sysConfig.$syscfg.K_Request("F0000037", _Object$assign({}, { SERVICE_CODE: "D1001625" }, {
              B_SNO: busiInfo.KIDM_SNO })).then(function (data) {
              if (data.Code == "0" && data.Data.length > 0) {
                return data.Data || [];
              }
              return [];
            }).catch(function (e) {
              console.log("获取影像系统数据失败", e);
            });

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 7:
            return _context2.abrupt("return", []);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }));

  return function getPrintImgClsCollectFlag(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

export var checkImgAndVideo = function () {
  var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this) {
    var that, flagImg, flagVideo, requestArr, checkImgFlag, busiInfo, imgClsArr;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            that = _this, flagImg = false, flagVideo = false, requestArr = [], checkImgFlag = true, busiInfo = _this.$storage.getJsonSession(_this.$definecfg.BUSI_INFO), imgClsArr = ["X33", "070", "X13", "119", "X35"];

            imgClsArr.forEach(function (item) {
              requestArr.push(getKidmImgContent({
                B_SNO: that.B_SNO,
                IMG_CLS: item,
                ID_CODE: _.get(busiInfo, "BIZ_DATA.KEY_INFO.NEW_ID_CODE", "")
              }));
            });
            _context3.next = 4;
            return _Promise.all(requestArr).then(function (res) {
              imgClsArr.forEach(function (imgcls) {
                var videoArr = ["X33", "X35"];
                if (that.busiData.BUSI_CODE == "QS421" || that.busiData.BUSI_FLAG == "2") {
                  videoArr = ["X33"];
                }
                if (videoArr.indexOf(imgcls) > -1) {
                  var temObj = _.find(res, { IMG_CLS: imgcls });
                  if (_.isEmpty(temObj) || !["0", "1", "4"].includes(temObj.REVIEW_STATUS)) {
                    flagVideo = true;
                  }
                }
                if (["070", "X13", "119"].indexOf(imgcls) > -1 && checkImgFlag) {
                  var temImgObj = _.find(res, { IMG_CLS: imgcls });
                  if (_.isEmpty(temImgObj) || !["0", "1", "4"].includes(temImgObj.REVIEW_STATUS)) {
                    flagImg = true;
                  } else {
                    checkImgFlag = false;
                    flagImg = false;
                  }
                }
              });
            }).catch(function (err) {
              console.log("获取历史影像失败");
            });

          case 4:
            console.log("执行请求视以及免冠照成功");
            return _context3.abrupt("return", {
              flagImg: flagImg,
              flagVideo: flagVideo
            });

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this2);
  }));

  return function checkImgAndVideo(_x5) {
    return _ref3.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./src/service/image-service.js
// module id = 89
// module chunks = 2